/* Štampa okreta — otvara print prozor sa P&L pregledom ture (podaci iz trip.PrintStampaOkreta). */
const fmt = (n) => Number(n ?? 0).toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtKurs = (n) => (n == null ? '-' : Number(n).toLocaleString('sr-RS', { minimumFractionDigits: 4, maximumFractionDigits: 4 }));
const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const handlePrintStampaOkreta = (data) => {
    const okretiRows = (data.okreti || []).map(o => `
        <tr>
          <td>${esc(o.nalogodavac)}</td>
          <td>${esc(o.relacija)}</td>
          <td class="c">${esc(o.datum)}</td>
          <td class="c">${esc(o.brojFakture)}</td>
          <td class="r">${o.cena != null ? fmt(o.cena) + (o.valuta ? ' ' + esc(o.valuta) : '') : ''}</td>
        </tr>`).join('');

    const vozaci = data.vozaci || [];

    // Zaduženja — Ukupno (EUR) po vozaču; KURS je poslednja kolona (rowspan, jedna vrednost)
    const zaduzenjaRows = vozaci.map((v, i) => `
        <tr>
          <td>${esc(v.vozac)}</td>
          <td class="r">${fmt(v.din)}</td>
          <td class="r">${fmt(v.eur)}</td>
          <td class="r">${fmt(v.ukupnoZad)} EUR</td>
          ${i === 0 ? `<td class="r" rowspan="${vozaci.length}" style="vertical-align:middle">${fmtKurs(data.kurs)}</td>` : ''}
        </tr>`).join('');

    // Obračun po vozaču — kolone: PLATA, TROŠAK, OSTALO, STANJE (bez amortizacije)
    const obracunRows = vozaci.map(v => `
        <tr>
          <td>${esc(v.vozac)}</td>
          <td class="r">${fmt(v.plata)}</td>
          <td class="r">${fmt(v.trosak)}</td>
          <td class="r">${fmt(v.ostalo)}</td>
          <td class="r">${fmt(v.stanje)}</td>
        </tr>`).join('');

    const html = `<!DOCTYPE html>
<html lang="sr"><head><meta charset="utf-8"><title>Štampa okreta — ${esc(data.brojPutnogNaloga)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Arial, "Segoe UI", sans-serif; font-size: 11pt; color: #111; margin: 0; padding: 16mm 14mm; }
  h1 { font-size: 15pt; margin: 0 0 4mm; text-align: center; letter-spacing: 1px; }
  h2 { font-size: 11pt; margin: 5mm 0 1.5mm; text-transform: uppercase; letter-spacing: .5px; border-bottom: 1px solid #bbb; padding-bottom: 1mm; }
  table { width: 100%; border-collapse: collapse; }
  th, td { border: 1px solid #999; padding: 1.6mm 2.5mm; text-align: left; font-size: 10pt; vertical-align: top; }
  th { background: #eee; }
  td.c, th.c { text-align: center; }
  td.r, th.r { text-align: right; white-space: nowrap; }
  .top { display: flex; gap: 6mm; align-items: flex-start; margin-bottom: 2mm; }
  .meta { flex: 1; }
  .meta td:first-child { width: 42mm; color: #555; background: #f7f7f7; }
  .okret-box { width: 55mm; border-collapse: collapse; }
  .okret-box td { text-align: center; }
  .okret-box .lbl { background: #eee; font-weight: 700; font-size: 9pt; letter-spacing: .5px; }
  .okret-box .val { font-size: 17pt; font-weight: 700; padding: 3mm 2mm; }
  tfoot td { background: #f4f4f4; font-weight: 700; }
  .fin { width: 70mm; margin-left: auto; margin-top: 2mm; }
  .fin td:first-child { color: #333; }
  .fin td.r { font-weight: 600; }
  .konacno { margin-top: 3mm; width: 70mm; margin-left: auto; }
  .konacno td { background: #eaf7ee; font-weight: 700; font-size: 11pt; border-color: #7bbf8f; }
  @page { size: A4 portrait; margin: 0; }
</style></head>
<body>
  <h1>ŠTAMPA OKRETA</h1>

  <div class="top">
    <table class="meta">
      <tr><td>Datum obračuna</td><td><b>${esc(data.datum)}</b></td></tr>
      <tr><td>Br. putnog naloga</td><td><b>${esc(data.brojPutnogNaloga)}</b></td></tr>
      <tr><td>Vozač</td><td>${esc(data.vozac)}</td></tr>
      <tr><td>Broj vozila</td><td><b>${esc(data.vozilo)}</b></td></tr>
      <tr><td>Br. dozvole / CEMT</td><td>${esc(data.dozvole) || '-'}</td></tr>
    </table>
    <table class="okret-box">
      <tr><td class="lbl">BROJ OKRETA</td></tr>
      <tr><td class="val">${esc(data.brojOkreta)}</td></tr>
    </table>
  </div>

  <h2>Nalozi</h2>
  <table>
    <thead><tr><th>Nalogodavac</th><th>Relacija</th><th class="c">Datum</th><th class="c">Broj fakture</th><th class="r">Cena</th></tr></thead>
    <tbody>${okretiRows || '<tr><td colspan="5" class="c">Nema radnih naloga.</td></tr>'}</tbody>
    <tfoot><tr><td colspan="4" class="r">PRIHOD (ukupno)</td><td class="r">${fmt(data.prihod)} EUR</td></tr></tfoot>
  </table>

  <h2>Zaduženja po vozaču</h2>
  <table>
    <thead><tr><th>Vozač</th><th class="r">Zaduženje DIN</th><th class="r">Zaduženje EUR</th><th class="r">Ukupno (EUR)</th><th class="r">KURS</th></tr></thead>
    <tbody>${zaduzenjaRows || '<tr><td colspan="5" class="c">Nema zaduženja.</td></tr>'}</tbody>
  </table>
  <p style="margin:1mm 0 0;font-size:8.5pt;color:#666">KURS: preračunato u EUR po kursu na datum obračuna (RSD/EUR).</p>

  <h2>Obračun po vozaču</h2>
  <table>
    <thead><tr>
      <th>Vozač</th><th class="r">PLATA</th><th class="r">TROŠAK</th><th class="r">OSTALO</th><th class="r">STANJE</th>
    </tr></thead>
    <tbody>${obracunRows || '<tr><td colspan="5" class="c">Nema vozača.</td></tr>'}</tbody>
  </table>

  <h2>Konačni obračun</h2>
  <table class="konacno" style="margin-left:0;width:95mm;font-size:13pt">
    <tr><td style="width:60%;background:#d4edda;padding:2.4mm 3mm">UKUPNO NALOZI:</td><td class="r" style="background:#d4edda;padding:2.4mm 3mm">${fmt(data.prihod)} €</td></tr>
    <tr><td style="background:#f8d7da;padding:2.4mm 3mm">UKUPNO TROŠKOVA:</td><td class="r" style="background:#f8d7da;padding:2.4mm 3mm">${fmt(data.ukupnoTroskova)} €</td></tr>
    <tr><td style="background:#cce5ff;padding:2.4mm 3mm">UKUPNO RAZLIKA:</td><td class="r" style="background:#cce5ff;padding:2.4mm 3mm">${fmt(data.razlika)} €</td></tr>
  </table>

  ${data.napomenaNalog ? `<p style="margin-top:4mm;font-size:10pt"><b>Napomena naloga:</b> ${esc(data.napomenaNalog)}</p>` : ''}
</body></html>`;

    // Otvara zaseban prozor za štampu (isto kao štampa putnog naloga)
    const printWindow = window.open('', '_blank', 'width=1000,height=700');
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    setTimeout(() => {
        printWindow.focus();
        printWindow.print();
    }, 300);
};

export default handlePrintStampaOkreta;
